import { EEventStates } from "@gift/types";

export const isEventFinalState = (state: EEventStates) =>
    [
        EEventStates.GOAL_AMOUNT_REACHED,
        EEventStates.ARCHIVED_BY_USER,
        EEventStates.ARCHIVED_BY_SYSTEM,
    ].includes(state);
